exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div[data-v-c320d908]{padding-top:50px}h1[data-v-c320d908],h2[data-v-c320d908]{text-align:center}h1[data-v-c320d908]{color:#008bd0;font-family:ClanFFBlack;font-size:100px;font-weight:400;display:block}h2[data-v-c320d908]{color:#008bd0;font-family:ClanFFBlack;font-size:40px;color:#e6e7e8}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c320d908","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Global/ErrorNotFound.vue
// module id = 453
// module chunks = 0